//Copyright Open Trade Technology Ltd. 2023. All rights reserved.

import { Box, Button, Grid } from '@mui/material'
import React, { useState } from 'react'

import { CollateralCTO, CollateralSchema } from '@shared/PoolOffchainDataCTO'

import { onPromise } from '@react/components/UiHelpers'
import { SectionHeader } from '@react/components/common/SectionHeader'
import EditField from '@react/components/elements/EditField'
import { useOtChainState } from '@react/redux/store'

import { yupResolver } from '@hookform/resolvers/yup'
import { logOT } from '@shared/loggingShared'
import { SubmitHandler, useForm } from 'react-hook-form'

export default function PoolOffchainCollateralForm(props: {
  collateralCTO: CollateralCTO
  index: number
  updateCollateral: (collateral: CollateralCTO, index: number) => void
}): React.ReactElement {
  const { collateralCTO, updateCollateral } = props

  const {
    stageConfiguration: { serverApiBaseUrl },
  } = useOtChainState()

  const [isSubmitted, setIsSubmitted] = useState<boolean>(false)

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<CollateralCTO>({
    defaultValues: collateralCTO,
    resolver: yupResolver(CollateralSchema),
  })

  const onErrors = (errors: any) => {
    logOT.info('ERRORS: ', errors)
  }

  const onSubmit: SubmitHandler<CollateralCTO> = async (collateralCTOUpdated: CollateralCTO): Promise<void> => {
    logOT.info('poolFormData', collateralCTOUpdated)
    if (serverApiBaseUrl) {
      setIsSubmitted(true)
      updateCollateral(collateralCTOUpdated, props.index)
      const event = new Event('modalClose')
      window.dispatchEvent(event)
    }
  }
  logOT.info('PoolOffchainCollateralForm initialValues', collateralCTO)
  return (
    <Box>
      <form onSubmit={onPromise(handleSubmit(onSubmit, onErrors))}>
        <SectionHeader>Collateral</SectionHeader>
        <Grid container spacing={1} sx={{ marginTop: 4 }}>
          <Grid item sm={6}>
            <EditField
              errors={errors}
              register={register}
              initialValues={collateralCTO}
              fieldSchema={CollateralSchema.describe().fields.collateralType}
            ></EditField>
          </Grid>
          <Grid item sm={6}>
            <EditField
              errors={errors}
              register={register}
              initialValues={collateralCTO}
              fieldSchema={CollateralSchema.describe().fields.collateralId}
            ></EditField>
          </Grid>

          <Grid item xs={12} sm={6}>
            <Button
              disabled={isSubmitted}
              type="submit"
              variant="contained"
              sx={{ marginBottom: 4 }}
              onClick={() => handleSubmit(onSubmit, onErrors)}
            >
              Save
            </Button>
          </Grid>
        </Grid>
      </form>
    </Box>
  )
}
